import { render, staticRenderFns } from "./PresentationStudentContent.vue?vue&type=template&id=4b7ad6ee&scoped=true"
import script from "./PresentationStudentContent.vue?vue&type=script&lang=js"
export * from "./PresentationStudentContent.vue?vue&type=script&lang=js"
import style0 from "./PresentationStudentContent.vue?vue&type=style&index=0&id=4b7ad6ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ad6ee",
  null
  
)

export default component.exports